import { inject, Injectable } from '@angular/core';
import { ApiResponseModel, ApiService } from '@solcre-org/core';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment.local';
import { PortModel } from '../models/port.model';
import { PortCallModel } from '../models/port-call.model';
import { BookingItemModel } from '../models/booking-item.model';
import { VoyageSummaryModel } from '../models/voyage-summary.model';
import { VoyageSegmentModel } from '../models/voyage-segment.model';
import { PortCallDetails } from '../interfaces/portcall-details.interface';
import { HttpParams } from '@angular/common/http';
import { BookingAttachmentModel } from '../models/booking-attachment.model';
import { BookingImportSuccess } from '../models/booking-import.model';

@Injectable({
  providedIn: 'root',
})
export class BookingService {
  private apiService: ApiService = inject(ApiService);

  public exportBookings(activeFilters: Map<string, any>): Observable<Blob> {
    const httpParams = this.buildHttpParams(activeFilters);

    return this.apiService.downloadFile(
      environment.API.BOOKING_EXPORT_URI,
      httpParams,
      `bookings_${new Date().toISOString().split('T')[0]}.xlsx`
    );
  }

  public downloadBookingImportTemplate(): Observable<Blob> {
    return this.apiService.downloadFile(
      environment.API.BOOKING_IMPORT_TEMPLATE_URI,
      {},
      'booking-import-template.xlsx'
    );
  }

  public importBookings(file: File): Observable<BookingImportSuccess> {
    return this.apiService
      .createObj(environment.API.BOOKING_IMPORT_URI, { file }, true)
      .pipe(map((response: ApiResponseModel) => response.data as BookingImportSuccess));
  }

  public uploadBookingAttachment(bookingId: any, file: File): Observable<any> {
    return this.apiService.createObj(
      environment.API.BOOKING_ATTACHMENTS_URI.replace(':id', bookingId),
      {
        file: file,
      }
    );
    // .pipe(catchError(() => of(null)));
  }

  public deleteBookingAttachment(
    bookingId: any,
    attachmentId: any
  ): Observable<boolean> {
    return this.apiService.deleteObj(
      environment.API.BOOKING_ATTACHMENTS_URI.replace(':id', bookingId),
      attachmentId
    );
  }

  public downloadBookingAttachment(
    attachmentId: any,
    attachmentName: string
  ): Observable<any> {
    return this.apiService
      .fetchData(
        environment.API.BOOKING_ATTACHMENTS_DOWNLOAD_URI.replace(
          ':id',
          attachmentId
        )
      )
      .pipe(
        // El primer request devuelve { url: string }
        switchMap((res: ApiResponseModel) => {
          const url: string = res.data?.url;
          if (url) {
            return this.apiService.downloadExternalFile(
              url,
              {},
              attachmentName
            );
          }
          return of(null);
        })
      );
  }

  private buildHttpParams(activeFilters: Map<string, any>): HttpParams {
    let httpParams = new HttpParams();
    activeFilters.forEach((value, key) => {
      httpParams = httpParams.set(key, value);
    });
    return httpParams;
  }
}
